/* Belle's Secrets — collection page (filter drawer + auto-apply + sort) */
(function () {
  function init(root) {
    if (root.dataset.bsCollReady) return;
    root.dataset.bsCollReady = '1';

    function openFilters() { root.classList.add('is-filters-open'); document.body.style.overflow = 'hidden'; }
    function closeFilters() { root.classList.remove('is-filters-open'); document.body.style.overflow = ''; }

    root.querySelectorAll('[data-bs-filter-open]').forEach(function (b) { b.addEventListener('click', openFilters); });
    root.querySelectorAll('[data-bs-filter-close]').forEach(function (b) { b.addEventListener('click', closeFilters); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-filters-open')) closeFilters(); });

    /* Auto-apply filters on change */
    var form = root.querySelector('[data-bs-filter-form]');
    if (form) {
      form.addEventListener('change', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
      });
    }

    /* Sort — preserve current filters, reset page */
    var sort = root.querySelector('[data-bs-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  }
  function boot() { document.querySelectorAll('[data-bs-collection]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
